// extracted by mini-css-extract-plugin
module.exports = {"header":"TruckShowContainer_header__1JNxl"};